export default __webpack_public_path__ + "static/media/013-botanic.2b83cfd0.svg";